/** Staff menu/CRUD helpers. Full admin always passes. */

const PATH_MENU = [
  ["/dashboard", "dashboard"],
  ["/customers", "customers"],
  ["/resellers", "resellers"],
  ["/users", "users"],
  ["/templates", "templates"],
  ["/live-calls", "live-calls"],
  ["/servers/opensips", "servers-opensips"],
  ["/servers/media", "servers-media"],
  ["/servers/ai-engines", "servers-ai-engines"],
  ["/ai-bots/models", "ai-bots-models"],
  ["/ai-bots/tts", "ai-bots-tts"],
  ["/ai-bots/stt", "ai-bots-stt"],
  ["/servers/vicidial", "servers-vicidial"],
  ["/billing/pricing", "billing-pricing"],
  ["/billing/payments", "billing-payments"],
  ["/cdr/reseller", "cdr-reseller"],
  ["/cdr", "cdr"],
  ["/reports/stats", "reports-stats"],
  ["/reports/payment-history", "reports-payment-history"],
  ["/reports/reseller-payment", "reports-reseller-payment"],
  ["/reports/commissions", "reports-commissions"],
  ["/reports", "reports"],
  ["/staff-knowledge-bases", "staff-knowledge-bases"], // also covers /staff-knowledge-bases/:id
  ["/settings", "settings"],
  ["/branding", "branding"],
  ["/system-logs", "system-logs"],
];

export function can(user, menuKey, action = "view") {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (user.role !== "staff") return false;
  const acts = (user.permissions && user.permissions[menuKey]) || [];
  return acts.includes(action);
}

export function menuKeyForPath(path) {
  const p = (path || "").replace(/\/$/, "") || "/";
  let best = null;
  let bestLen = -1;
  for (const [prefix, key] of PATH_MENU) {
    if (p === prefix || p.startsWith(prefix + "/")) {
      if (prefix.length > bestLen) {
        best = key;
        bestLen = prefix.length;
      }
    }
  }
  return best;
}

export function canViewPath(user, path) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (user.role !== "staff") return true; // non-staff use RoleGuard roles
  const key = menuKeyForPath(path);
  if (!key) return false;
  // Users management is admin-only
  if (key === "users") return false;
  // Staff always see their own commissions report
  if (key === "reports-commissions") return true;
  // Staff always see Knowledge Bases filtered to their group (Sales/Support)
  if (key === "staff-knowledge-bases") return true;
  return can(user, key, "view");
}

export function firstAllowedPath(user) {
  if (!user || user.role !== "staff") return "/dashboard";
  for (const [path, key] of PATH_MENU) {
    if (key === "users") continue;
    if (can(user, key, "view")) return path;
  }
  return "/dashboard";
}

export function isPlatformOperator(user) {
  return user?.role === "admin" || user?.role === "staff";
}

/** Admin, reseller, or Support-group staff may use backdoor login. */
export function canImpersonate(user) {
  if (!user) return false;
  if (user.role === "admin" || user.role === "reseller") return true;
  if (user.role === "staff") return !!user.can_impersonate;
  return false;
}
